import { render, staticRenderFns } from "./inputFormatNumber.vue?vue&type=template&id=4e2b7e3a"
import script from "./inputFormatNumber.vue?vue&type=script&lang=js"
export * from "./inputFormatNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports